$(function () {

    if ($("#user-profile").length) {

        $('.nav-tabs-responsive a').on('click', function (e) {
            e.preventDefault();
            $(this).tab('show');

            setTimeout(function () {
                $(window).resize();
            }, 500);
        });

        var userId = $('#current-user-id').val();

        $('.edit-insider').on('click', function () {
            $(this).closest('.detail-row')
                .find('.form-control')
                .prop('disabled', false)
                .focus();
        });

        $('#insiderPassword').on('keyup', function () {
            if ($(this).val() !== "") {
                $("#confirm-password-row").removeClass('d-none');
            } else {
                $("#confirm-password-row").addClass('d-none');
            }
        });

        // Display new search button
        $('.property-grid .tab-header .nav-link').on('click', function () { $('.btn-search').removeClass('is-active'); });
        $('.insider-saved').on('click', function () { $('.btn-search').addClass('is-active'); });

        // If there are errors in the edit profile modal, open the modal
        if ($("#update-profile-errors-alert").length) {
            setTimeout(function () {
                $('#edit-profile-modal').modal('show');
            }, 300);
        }

        $('.alert-notification-toggle').on('click', function () {
            $.post("/wp/wp-admin/admin-ajax.php", {
                'action': 'toggle_saved_search_alerts',
                'user_id': userId,
                'saved_search_id': $(this).data('saved-search-id'),
                'status': $(this).data('value')
            }, function (data) { });
        });

        $('.toggle-email-notifications').on('click', function () {
            $.post("/wp/wp-admin/admin-ajax.php", {
                'action': 'toggle_email_notifications',
                'user_id': $('#current-user-id').val(),
                'status': $(this).data('value')
            }, function (data) { });
        });

        // Check if the initial email prompt hidden input and show if needed
        if ($('#prompt_for_email_newsletter').length) {
            setTimeout(function () {
                $('#prompt-for-email-newsletter').modal('show');
            }, 1000);
        }

        // If the user says yes to the newsletter signup, send that request and update the user
        $('#confirm-initial-email-signup').on('click', function () {
            $.post("/wp/wp-admin/admin-ajax.php", {
                'action': 'toggle_email_notifications',
                'user_id': userId,
                'status': 'on'
            }, function (data) {
                $('#prompt-for-email-newsletter').modal('hide');
                setTimeout(function () {
                    window.helpers.showNotification('Thanks for signing up!');
                }, 500);
            });
        });

        $('.remove-search-button').on('click', function () {

            var searchId = $(this).data('search-id'),
                userId = $('#current-user-id').val();

            $.post("/wp/wp-admin/admin-ajax.php", {
                'action': 'save_property_search_remove',
                'user_id': userId,
                'search_id': searchId
            }, function (data) {
                $('#saved-search-' + searchId).fadeOut();
                setTimeout(function () {
                    $('#saved-search-' + searchId).remove();
                }, 500);
            });
        });

    }

});
